<template>
<header>
  <h1>
    <nav>
      <ul>
        <li class="masthead">
          <router-link
            :to="{
              name: 'home'
            }"
          >
            <span
            v-if="brandings.brand_name">
              {{ brandings.brand_name }} Admin
            </span>
          </router-link>
        </li>
      </ul>
    </nav>
  </h1>
</header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    brandings: state => state.SettingModule.brandings
  }),

  created () {
    // May need to retrieve branding data, if necessary.
    if (this.brandings && !this.brandings.brand_name) {
      this.$store.commit('SettingModule/storeBrandingsFromLocalstore')
    }
  }
}
</script>

<style scoped>
nav, nav ul {
  display: block;
  width: 100%
}

nav .icon {
  margin: 0;
  padding: 0
}

nav .masthead {
  text-align: center
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue